import { connect, ConnectedProps } from "react-redux";
import * as jwt_decode from "jwt-decode";
import { AppState } from "../../../../redux/reducers";
import { Payment } from "../../../../models/Entities/CashFlow/Payment/Payment";
import { nameOf } from "../../General/Cashflow.General.Functions";

export interface IProps {
    paymentId: number | null;
    isOpen: boolean;
    onClose: () => void;
    title?: string;
}

const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const tenantId = state?.oidc?.user?.access_token
        ? ((jwt_decode.jwtDecode(state.oidc.user.access_token) as { tenantId?: string })?.tenantId ?? '')
        : '';
    const persons = state.Persons?.list ?? [];
    const done: Payment[] = state.CashFlowPayments?.paymentsDone ?? [];
    const received: Payment[] = state.CashFlowPayments?.paymentsReceived ?? [];
    const payment = ownProps.paymentId
        ? received.find((item) => item.id === ownProps.paymentId) ?? done.find((item) => item.id === ownProps.paymentId)
        : undefined;

    return {
        Payment: payment,
        /** El centro cobró (true) o pagó (false). */
        IsReceived: !!payment && payment.receiver === tenantId,
        NameOf: (identifier: string | undefined) => nameOf(persons, tenantId, identifier || '')
    };
};

export const connector = connect(mapStateToProps, {});
export type Props = IProps & ConnectedProps<typeof connector>;
